import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

interface MenuItem {
  title: string;
  id?: string;
  children?: MenuItem[];
}

export const useGeneratesMenu = (
  containerRef: React.RefObject<HTMLDivElement>
) => {
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);

  useEffect(() => {
    if (!containerRef.current) return;

    const newMenuItems: MenuItem[] = [];
    const headings = containerRef.current.querySelectorAll('h2, h3');

    headings.forEach((heading) => {
      const headingText = heading.textContent;
      const uniqueId = uuidv4();
      heading.setAttribute('id', uniqueId);

      if (heading.tagName.toLowerCase() === 'h2') {
        newMenuItems.push({
          title: headingText,
          id: uniqueId,
          children: [],
        });
      } else if (heading.tagName.toLowerCase() === 'h3') {
        const currentH2 = newMenuItems[newMenuItems.length - 1];
        if (currentH2) {
          currentH2.children?.push({ title: headingText, id: uniqueId });
        }
      }
    });

    setMenuItems(newMenuItems);
  }, [containerRef]);

  const handleScroll = (id: string) => {
    const target = document.getElementById(id);
    if (!target) return;
  

    const yOffset = window.innerWidth < 768 ? -150 : -200; 
  
    const yPosition =
      target.getBoundingClientRect().top + window.scrollY + yOffset;
  
    window.scrollTo({ top: yPosition, behavior: 'smooth' });
  };

  return { menuItems, handleScroll };
};
